// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1fbd0440","239":"0c18ef5a","455":"15277626"}[chunkId] + ".chunk.js";
};